// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"0b0dd3b9","787":"656ff921"}[chunkId] + ".chunk.js";
};